<template>
  <slot :openNewCreatePageWithDuplicateData="openNewCreatePageWithDuplicateData">
    <span
      @click.prevent.stop="() => openNewCreatePageWithDuplicateData()"
      :class="buttonClass"
      >{{ buttonText }}
    </span>
  </slot>
</template>
<script lang="ts">
import { PropType } from 'vue'

type DataDuplicateFunction = (params: {
  duplicatedRecordBasedOnModel: Record<string, any>
  editingRecord: Record<string, any>
  modelName: string
  virtualModelName: string
}) => Promise<Record<string, any>>

/**
 * レコード複製ボタン
 *
 */
export default {
  name: 'RecordDuplicateButton',
  inject: ['ModelFormServiceInstance'],
  props: {
    // 複製する際の ロジックの オーバーライド関数
    dataDuplicateFunction: {
      type: Function as PropType<DataDuplicateFunction>,
      required: true,
    },
    openFormInModal: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '複製する',
    },
    buttonClass: {
      type: String,
      default: 'btn btn-outline-primary',
    },
  },
  emits: ['duplicated'],
  computed: {
    modelName() {
      return this.ModelFormServiceInstance.modelName
    },
    virtualModelName() {
      return this.ModelFormServiceInstance.virtualModelName
    },
    editingRecord() {
      return this.ModelFormServiceInstance.$modelFormVueInstance.data
    },
    model() {
      return this.ModelFormServiceInstance.model
    },
    columns() {
      return this.model?.columns
    },
  },
  methods: {
    async openNewCreatePageWithDuplicateData() {
      try {
        let record = await this.createDuplicateDataBasedOnModel()
        if (typeof this.dataDuplicateFunction === 'function') {
          const editingRecord = JSON.parse(JSON.stringify(this.editingRecord))
          record = await this.dataDuplicateFunction({
            duplicatedRecordBasedOnModel: record,
            editingRecord: editingRecord,
            modelName: this.modelName,
            virtualModelName: this.virtualModelName,
          })
        }
        if (this.openFormInModal) {
          $core.$modals.openCreateViewModal({
            modelName: this.modelName,
            virtualModelName: this.virtualModelName,
            defaultValues: record,
          })
        } else {
          // 非常に短い時間で 複製データをキャッシュしておき、ページ側で キャッシュを参照する
          $core.$obCache.set(`replication-data--${this.modelName}`, record, 20)
          $core.$router.push({
            name: 'fallback_model-new',
            params: {
              fallback_model: this.modelName,
            },
            query: {
              virtualModel: this.virtualModelName || undefined,
              use_duplicate: 'true',
            },
          })
        }
        this.$emit('duplicated')
      } catch (e) {
        console.error(e)
      }
    },
    createDuplicateDataBasedOnModel() {
      // recordから複製可能なカラムのみを抽出
      return $core.$utils.createDuplicateDataBasedOnModel({
        modelName: this.modelName,
        virtualModelName: this.virtualModelName,
        editingRecord: this.editingRecord,
      })
    },
  },
}
</script>
